module.exports = "/cyber/_next/static/images/headphones-0000b60c3fff4fda3967f30636d0b82a.png";